module.exports = __webpack_public_path__ + "static/media/email-avatar.6424b806.svg";